import { resolveLiveChatAppSettings } from "@jugl-web/domain-resources/chat-bot/utils/resolveLiveChatAppSettings";
import { PlainButton } from "@jugl-web/ui-components/cross-platform";
import { Tooltip } from "@jugl-web/ui-kit";
import { useRestApiProvider } from "@jugl-web/rest-api";
import { environment } from "@web-src/environments/environment";
import { BrowserWindowShell } from "@web-src/modules/client-support/pages/ClientSupportPage/components/ManageAccountsDrawer/components/BrowserWindowShell";
import { ChatbotPreviewBackground } from "@web-src/modules/client-support/pages/ClientSupportPage/components/ManageAccountsDrawer/screens/WebChatBotAccountScreen/components/ChatbotPreviewBackground";
import { useEntitySelectedProvider } from "@web-src/modules/entities/providers/EntityProvider/useEntitySelectedProvider";
import { FC, useMemo, useRef } from "react";
import { ReactComponent as RefreshIcon } from "./assets/refresh.svg";

export const LiveChatPreview: FC = () => {
  const { entity, entityId } = useEntitySelectedProvider();
  const { integrationsApi } = useRestApiProvider();

  const { data: liveChatAppConfig } =
    integrationsApi.useGetLiveChatAppConfigQuery({
      entityId,
    });

  const resolvedSettings = useMemo(
    () => resolveLiveChatAppSettings(liveChatAppConfig?.settings),
    [liveChatAppConfig?.settings]
  );

  const liveChatUrl = `${environment.liveChatUrl}/${entity.uniqueId}`;

  const iframeRef = useRef<HTMLIFrameElement>(null);

  const handleRefresh = () => {
    const iframe = iframeRef.current;

    if (!iframe) {
      return;
    }

    iframe.src = "";
    iframe.src = liveChatUrl;
  };

  return (
    <ChatbotPreviewBackground>
      <div className="flex h-full w-full animate-fade-in items-center justify-center p-10">
        <BrowserWindowShell
          tabTitle={resolvedSettings.browserTabTitle}
          faviconSrc={resolvedSettings.faviconUrl || null}
          endSlot={
            <Tooltip
              placement="bottom"
              renderTrigger={({ ref, props }) => (
                <PlainButton
                  ref={ref}
                  className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg transition-colors hover:bg-grey-200 active:bg-[#E0E0E0] disabled:cursor-not-allowed disabled:opacity-40"
                  onClick={handleRefresh}
                  {...props}
                >
                  <RefreshIcon />
                </PlainButton>
              )}
            >
              Refresh preview
            </Tooltip>
          }
        >
          <iframe
            ref={iframeRef}
            src={liveChatUrl}
            title="Live Chat Preview"
            allow="microphone; camera"
            className="h-full w-full border-none"
          />
        </BrowserWindowShell>
      </div>
    </ChatbotPreviewBackground>
  );
};
